<template>
  <div class="starry-background">
    <div class="stars">
      <div class="star" v-for="n in 300" :key="n"
           :style="{
             left: `${Math.random() * 100}%`,
             top: `${Math.random() * 100}%`,
             animationDelay: `${Math.random() * 10}s`,
             '--float-duration': `${20 + Math.random() * 40}s`,
             '--float-distance': `${100 + Math.random() * 300}px`,
             '--float-direction': `${Math.random() * 360}deg`
           }">
      </div>
    </div>
  </div>
</template>

<style scoped>
.starry-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: -1;
  background: linear-gradient(circle at 50% 50%,
    var(--my-dark) 0%,
  var(--my-border) 50%,
    var(--my-black) 100%
  );
  overflow: hidden;
}

.stars {
  position: absolute;
  width: 100%;
  height: 100%;
}

.star {
  position: absolute;
  width: 1px;
  height: 1px;
  background: #fff;
  border-radius: 50%;
  opacity: 0;
  animation: twinkle 4s infinite cubic-bezier(0.4, 0, 0.6, 1);
  transform: translateZ(0);
}

.star::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  background: inherit;
  filter: blur(1px);
}

@keyframes twinkle {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  25% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(0.7);
    opacity: 0.4;
  }
  75% {
    transform: scale(1.2);
    opacity: 0.7;
  }
  100% {
    transform: scale(0.5);
    opacity: 0;
  }
}

/* Добавляем больше вариаций размеров звезд */
.star:nth-child(11n) {
  width: 1.5px;
  height: 1.5px;
}

.star:nth-child(3n) {
  width: 2px;
  height: 2px;
}

.star:nth-child(5n) {
  width: 0.5px;
  height: 0.5px;
}

/* Добавляем еще один размер для разнообразия */
.star:nth-child(13n) {
  width: 0.7px;
  height: 0.7px;
}

/* Добавляем легкое свечение некоторым звездам */
.star:nth-child(7n)::after {
  filter: blur(2px);
  box-shadow: 0 0 2px rgba(255, 255, 255, 0.7), 0 0 4px rgba(255, 255, 255, 0.5);
}

/* Добавляем более яркое свечение некоторым звездам */
.star:nth-child(19n)::after {
  filter: blur(1px);
  box-shadow: 0 0 3px rgba(255, 255, 255, 0.9), 0 0 6px rgba(255, 255, 255, 0.7);
}

/* Создаем эффект параллакса, разные звезды двигаются с разной скоростью */
.star:nth-child(2n) {
  animation: twinkle 6s infinite cubic-bezier(0.4, 0, 0.6, 1),
             floatRandom var(--float-duration) infinite linear;
}

.star:nth-child(3n) {
  animation: twinkle 7s infinite cubic-bezier(0.4, 0, 0.6, 1),
             floatRandom var(--float-duration) infinite ease-in-out;
}

.star:nth-child(5n) {
  animation: twinkle 5s infinite cubic-bezier(0.4, 0, 0.6, 1),
             floatRandom var(--float-duration) infinite ease-in;
}

.star:nth-child(7n) {
  animation: twinkle 8s infinite cubic-bezier(0.4, 0, 0.6, 1),
             floatRandom var(--float-duration) infinite ease-out;
}

@keyframes floatRandom {
  from {
    transform: translateY(0) translateX(0);
  }
  to {
    transform: rotate(var(--float-direction)) translateX(var(--float-distance));
  }
}

/* Добавляем случайное мерцание для некоторых звезд */
.star:nth-child(11n) {
  animation-timing-function: steps(4, end);
}

.star:nth-child(13n) {
  animation-timing-function: steps(6, end);
}

/* Добавляем более яркое свечение для редких звезд */
.star:nth-child(23n)::after {
  filter: blur(1px);
  box-shadow: 0 0 4px rgba(255, 255, 255, 1), 0 0 8px rgba(255, 255, 255, 0.8);
}
</style>

<script>
export default {
  name: 'StarryBackground'
}
</script>
